export default function ArrowUpIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="10"
      fill="none"
      viewBox="0 0 16 10"
    >
      <path
        fill="#677484"
        d="M7.336 1.086a.92.92 0 0 1 1.289 0l6.29 6.25c.35.39.35.976 0 1.328-.392.39-.977.39-1.33 0L8 3.078 2.414 8.664c-.39.39-.977.39-1.328 0a.855.855 0 0 1 0-1.289l6.25-6.29Z"
      />
    </svg>
  )
}
